﻿import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { FEATURE_PERMISSIONS } from "@/utils/constants/featurePermissions";
import { useFeaturePermission } from "@/utils/hooks/useFeaturePermission";
import {NO_GROUP_ASSIGNED} from '@/utils/constants/messages';
import { TabListSkeleton } from "@/components/skeletons";

interface RoleGroupsProps {
    roleGroups: any;
    getGroupDetails: (id: string) => void;
    isLoading: boolean;
}
const RoleGroups: React.FC<RoleGroupsProps> = (props) => {
    const onDeleteClicked = (id: string) => {
        props.getGroupDetails(id);
    };

    /**
     * RBAC BEGIN
     */
    const isViewGroupPermitted = useFeaturePermission(FEATURE_PERMISSIONS.AdminPortalViewGroup);
    const isUpdateGroupPermitted = useFeaturePermission(FEATURE_PERMISSIONS.AdminPortalUpdateGroup);
    /**
     * RBAC END
     */
    return (
        <div>
            <div>
                {props.roleGroups && !props.isLoading ? (
                    props.roleGroups.length > 0 ? (
                        <div className="gs-list-page-card">
                            <ul className="gs-detail-list">
                                {props.roleGroups.map((group: any, key: string) => {
                                    return (
                                        <li className="gs-detail-list-item" key={key}>
                                            <div className="gs-detail-list-name">
                                                <Link className="text-primary hover:underline" to={`/group/${group?.id}`} id={`role-detail-group-tab-name-${key}`}>{group.name}</Link>
                                            </div>
                                            <div className="gs-detail-list-action">
                                                {isViewGroupPermitted && isUpdateGroupPermitted && (
                                                    <a href={"#"} id={group?.id} className="link-primary p-0">
                                                        <em id={`role-detail-group-tab-delete-icon-${key}`} className="icon ni ni-trash" onClick={() => onDeleteClicked(group?.id)} />
                                                    </a>
                                                )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ) : (
                        <span className="gs-detail-list-item text-sm text-card-foreground" id='role-detail-group-tab-no-data-meesage'>{NO_GROUP_ASSIGNED}</span>
                    )
                ) : (
                    <TabListSkeleton id="role-group-tab" />
                )}
            </div>
        </div>
    );
};

export default RoleGroups;
